export enum PlanLocationOverrideRuleStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export const PLAN_LOCATION_OVERRIDE_TEMPLATE = 'UPSERT_RULE' as const
export type PlanLocationOverrideRuleTemplateKey =
  typeof PLAN_LOCATION_OVERRIDE_TEMPLATE
